export default {
  1: {
    label: 'Company Name',
    type: 'text',
    name: 'name',
    placeholder: 'Acme, Inc',
    validation: {
      required: true,
    },
    icon: 'building',
  },

  3: {
    type: 'html',
    html: '<hr><h2 class="subtitle">Section 1. Organizational Health</h2>',
  },
  4: {
    label: '1. I believe my company is going in the right direction.',
    type: 'slider',
    name: 'culture-direction',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },
  5: {
    label: '2. My company operates by strong values and ethics.',
    type: 'slider',
    name: 'culture-ethics',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },
  6: {
    label: '3. There is good interdepartmental cooperation at this company.',
    type: 'slider',
    name: 'culture-cooperation',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },
  7: {
    label: '4. There is a lot of negativity at my workplace.',
    type: 'slider',
    name: 'culture-negativity',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },

  8: {
    label: '5. At my company, we do things efficiently and well.',
    type: 'slider',
    name: 'culture-informed',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },
  9: {
    label: '6. Senior managers understand what is really happening at my company.',
    type: 'slider',
    name: 'culture-liked',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },
  11: {
    label: '7. My company encourages different points of view.',
    type: 'slider',
    name: 'ethics-values',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },
  12: {
    label: '8. New ideas are encouraged at my company.',
    type: 'slider',
    name: 'ethics-social',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },
  13: {
    label: '9. My company enables me to work at my full potential.',
    type: 'slider',
    name: 'ethics-recommend',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },
  14: {
    label: '10. I feel genuinely appreciated at my company.',
    type: 'slider',
    name: 'ethics-flexibility',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },
  15: {
    label: '11. My job makes me feel like I am part of something meaningful.',
    type: 'slider',
    name: 'ethics-meaningful',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },
  16: {
    label: '12. I feel well-informed about important decisions at my company.',
    type: 'slider',
    name: 'ethics-trust',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },
  18: {
    label: '13. My manager cares about my concerns.',
    type: 'slider',
    name: 'leadership-confidence',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },
  19: {
    label: '14. My manager helps me learn and grow.',
    type: 'slider',
    name: 'leadership-perspective',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },
  20: {
    label: '15. My manager makes it easier to do my job well.',
    type: 'slider',
    name: 'leadership-expectations',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },

  22: {
    type: 'html',
    html: '<hr><h2 class="subtitle">Section 2: Engagement</h2>',
  },
  23: {
    label: '1. My company motivates me to give my very best at work.',
    type: 'slider',
    name: 'benefits-satisfied',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },
  24: {
    label: '2. I have considered searching for a better job in the past month.',
    type: 'slider',
    name: 'benefits-fair',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },

  36: {
    type: 'html',
    html: '<hr><h2 class="subtitle">Section 3. Leader</h2>',
  },
  37: {
    label: '1. I have confidence in the leader of my company.',
    type: 'slider',
    name: 'manager-easier',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },

  46: {
    type: 'html',
    html: '<hr><h2 class="subtitle">Section 4. The Basics</h2>',
  },
  47: {
    label: '1. I have the flexibility I need to balance my work and personal life.',
    type: 'slider',
    name: 'role-appreciated',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },
  48: {
    label: '2. I get the formal training I want for my career.',
    type: 'slider',
    name: 'role-potential',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },
  49: {
    label: '3. My pay is fair for the work I do.',
    type: 'slider',
    name: 'role-job-search',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },
  50: {
    label: '4. My benefits package is good compared to others in this industry.',
    type: 'slider',
    name: 'role-meetings',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },
  51: {
    label: '5. This job has met the expectations I had when I started.',
    type: 'slider',
    name: 'role-authority',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },
  52: {
    label: '6. My company is socially responsible.',
    type: 'slider',
    name: 'role-deadlines',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },
  53: {
    label: '7. It matters to me that my company is socially responsible.',
    type: 'slider',
    name: 'role-role',
    min: 1,
    max: 7,
    step: 1,
    labels: {
      leftSide: 'Strongly Disagree',
      center: 'Neutral',
      rightSide: 'Strongly Agree',
    },
    validation: {
      required: true,
    },
  },

  54: {
    type: 'html',
    html: '<hr><h2 class="subtitle">Section 5. Comments</h2><p><i>This section is optional.</i></p>',
  },
  55: {
    type: 'html',
    html: '<h3 class="subtitle">Motivation</h3>',
  },
  56: {
    label: 'What do you find most motivational about working for your company?',
    type: 'textarea',
    name: 'motivation-most',
    validation: {
      required: false,
    },
  },
  57: {
    label: 'Other than pay, how could your company better motivate you?',
    type: 'textarea',
    name: 'motivation-better',
    validation: {
      required: false,
    },
  },
  58: {
    type: 'html',
    html: '<h3 class="subtitle">Referral</h3>',
  },
  59: {
    label: 'What contributes most to your recommending working at your company to others?',
    type: 'textarea',
    name: 'referral-contribute',
    validation: {
      required: false,
    },
  },
  60: {
    label: 'What would make you more likely to recommend working at your company to others?',
    type: 'textarea',
    name: 'referral-likely',
    validation: {
      required: false,
    },
  },
  61: {
    type: 'html',
    html: '<h3 class="subtitle">Retention</h3>',
  },
  62: {
    label: 'What contributes most to you wanting to stay with your company?',
    type: 'textarea',
    name: 'retention-contribute',
    validation: {
      required: false,
    },
  },
  63: {
    label: 'Other than pay, what would make you less likely to leave your company?',
    type: 'textarea',
    name: 'retention-higher',
    validation: {
      required: false,
    },
  },
  64: {
    type: 'html',
    html: '<h3 class="subtitle">Leader</h3>',
  },
  65: {
    label: 'What does your leader do well?',
    type: 'textarea',
    name: 'leader-well',
    validation: {
      required: false,
    },
  },
  66: {
    label: 'What could your leader do better?',
    type: 'textarea',
    name: 'leader-better',
    validation: {
      required: false,
    },
  },
  67: {
    type: 'html',
    html: '<h3 class="subtitle">Values & Ethics</h3>',
  },
  68: {
    label: 'What impresses you most about the values and ethics of your company?',
    type: 'textarea',
    name: 'ethics-impress',
    validation: {
      required: false,
    },
  },
  69: {
    label: 'How is your company not operating by strong values and ethics?',
    type: 'textarea',
    name: 'ethics-not',
    validation: {
      required: false,
    },
  },
  70: {
    type: 'html',
    html: '<h3 class="subtitle">Direction</h3>',
  },
  71: {
    label: 'What excites you about the direction your company is taking?',
    type: 'textarea',
    name: 'direction-exciting',
    validation: {
      required: false,
    },
  },
  72: {
    label: 'What changes in direction would you like your company to make?',
    type: 'textarea',
    name: 'direction-change',
    validation: {
      required: false,
    },
  },
  73: {
    type: 'html',
    html: '<h3 class="subtitle">Cooperation</h3>',
  },
  74: {
    label: 'Which departments at your company cooperate really well?',
    type: 'textarea',
    name: 'cooperate-well',
    validation: {
      required: false,
    },
  },
  75: {
    label: 'Which departments at you company need to cooperate better?',
    type: 'textarea',
    name: 'cooperate-better',
    validation: {
      required: false,
    },
  },
  76: {
    type: 'html',
    html: '<h3 class="subtitle">Negativity</h3>',
  },
  77: {
    label: 'How does your company prevent negativity from building in the workplace?',
    type: 'textarea',
    name: 'negative-prevent',
    validation: {
      required: false,
    },
  },
  78: {
    label: 'What is the biggest source of negativity in your workplace?',
    type: 'textarea',
    name: 'negative-source',
    validation: {
      required: false,
    },
  },
  80: {
    type: 'html',
    html: '<h3 class="subtitle">Execution</h3>',
  },
  81: {
    label: 'What impresses you most about how your company does things efficiently and well?',
    type: 'textarea',
    name: 'execution-impress',
    validation: {
      required: false,
    },
  },
  82: {
    label: 'How could your company help you do things more efficiently and better?',
    type: 'textarea',
    name: 'execution-better',
    validation: {
      required: false,
    },
  },
  83: {
    type: 'html',
    html: '<h3 class="subtitle">Communications Up</h3>',
  },
  84: {
    label: 'What impresses you most about senior managers at your company?',
    type: 'textarea',
    name: 'comm-impress',
    validation: {
      required: false,
    },
  },
  85: {
    label: 'What is happening at your company that senior managers do not understand?',
    type: 'textarea',
    name: 'comm-understand',
    validation: {
      required: false,
    },
  },
  86: {
    type: 'html',
    html: '<h3 class="subtitle">Open-Mindedness</h3>',
  },
  87: {
    label: 'What does you company do to encourage different points of view?',
    type: 'textarea',
    name: 'open-encourage',
    validation: {
      required: false,
    },
  },
  88: {
    label: 'What happens at your company that discourages different points of view?',
    type: 'textarea',
    name: 'open-discourage',
    validation: {
      required: false,
    },
  },
  89: {
    type: 'html',
    html: '<h3 class="subtitle">Innovation</h3>',
  },
  90: {
    label: 'How does your company encourage new ideas?',
    type: 'textarea',
    name: 'inno-encourage',
    validation: {
      required: false,
    },
  },
  91: {
    label: 'How could your company better encourage new ideas?',
    type: 'textarea',
    name: 'inno-better',
    validation: {
      required: false,
    },
  },
  92: {
    type: 'html',
    html: '<h3 class="subtitle">Appreciation</h3>',
  },
  93: {
    label: 'What makes you feel appreciated at your company?',
    type: 'textarea',
    name: 'appreciation-feel',
    validation: {
      required: false,
    },
  },
  94: {
    label: 'What would make you feel more appreciated at your company?',
    type: 'textarea',
    name: 'appreciation-better',
    validation: {
      required: false,
    },
  },
  95: {
    type: 'html',
    html: '<h3 class="subtitle">Meaningfulness</h3>',
  },
  96: {
    label: 'What do you find most meaningul about working at your company?',
    type: 'textarea',
    name: 'meaning-most',
    validation: {
      required: false,
    },
  },
  97: {
    label: 'What would make your work feel more meaningful?',
    type: 'textarea',
    name: 'meaning-more',
    validation: {
      required: false,
    },
  },
  98: {
    type: 'html',
    html: '<h3 class="subtitle">Potential</h3>',
  },
  99: {
    label: 'How does your company use your full potential?',
    type: 'textarea',
    name: 'potential-use',
    validation: {
      required: false,
    },
  },
  100: {
    label: 'How could your company better use your full potential?',
    type: 'textarea',
    name: 'potential-better',
    validation: {
      required: false,
    },
  },
  101: {
    type: 'html',
    html: '<h3 class="subtitle">Communications Down</h3>',
  },
  102: {
    label: 'What ways do you find most useful for being informed about company decisions?',
    type: 'textarea',
    name: 'commdown-useful',
    validation: {
      required: false,
    },
  },
  103: {
    label: 'How could information about important decisions at your company be shared better?',
    type: 'textarea',
    name: 'commdown-better',
    validation: {
      required: false,
    },
  },
  104: {
    type: 'html',
    html: '<h3 class="subtitle">Concerns</h3>',
  },
  105: {
    label: 'What does your manager do to demonstrate that they care about your concerns?',
    type: 'textarea',
    name: 'concern-demonstrate',
    validation: {
      required: false,
    },
  },
  106: {
    label: 'What behaviors could your manager change to show that they care about your concerns?',
    type: 'textarea',
    name: 'concern-change',
    validation: {
      required: false,
    },
  },
  107: {
    type: 'html',
    html: '<h3 class="subtitle">Development</h3>',
  },
  108: {
    label: 'What does your manager do to help you learn and grow?',
    type: 'textarea',
    name: 'dev-grow',
    validation: {
      required: false,
    },
  },
  109: {
    label: 'What could your manager do to make it easier to do your job well?',
    type: 'textarea',
    name: 'dev-improve',
    validation: {
      required: false,
    },
  },
  110: {
    type: 'html',
    html: '<h3 class="subtitle">Helpfulness</h3>',
  },
  111: {
    label: 'How does your manager make it easier to do your job well?',
    type: 'textarea',
    name: 'help-good',
    validation: {
      required: false,
    },
  },
  112: {
    label: 'What could your manager do to make it easier to do your job well?',
    type: 'textarea',
    name: 'help-better',
    validation: {
      required: false,
    },
  },
  113: {
    type: 'html',
    html: '<h3 class="subtitle">Expectations</h3>',
  },
  114: {
    label: 'How has this job exceeded the expectations you had when you started?',
    type: 'textarea',
    name: 'expect-exceed',
    validation: {
      required: false,
    },
  },
  115: {
    label: 'What behaviors could your manager change to show that they care about your concerns?',
    type: 'textarea',
    name: 'expect-improve',
    validation: {
      required: false,
    },
  },
  116: {
    type: 'html',
    html: '<h3 class="subtitle">Work/Life</h3>',
  },
  117: {
    label: 'What do you appreciate most about how your company supports work/life flexibility?',
    type: 'textarea',
    name: 'wl-appreciate',
    validation: {
      required: false,
    },
  },
  118: {
    label: 'What improvements to work/life flexibility would you value most?',
    type: 'textarea',
    name: 'wl-improve',
    validation: {
      required: false,
    },
  },
  119: {
    type: 'html',
    html: '<h3 class="subtitle">Formal Training</h3>',
  },
  120: {
    label: 'What formal training have you found most valuable?',
    type: 'textarea',
    name: 'ftraining-valuable',
    validation: {
      required: false,
    },
  },
  121: {
    label: 'What kind of formal training would you value most?',
    type: 'textarea',
    name: 'ftraining-value',
    validation: {
      required: false,
    },
  },
  122: {
    type: 'html',
    html: '<h3 class="subtitle">Benefits</h3>',
  },
  123: {
    label: 'What aspects of your benefits package do you find most valuable?',
    type: 'textarea',
    name: 'benefits-value',
    validation: {
      required: false,
    },
  },
  124: {
    label: 'How would you like your benefits package improved?',
    type: 'textarea',
    name: 'benefits-improve',
    validation: {
      required: false,
    },
  },


  154: {
    type: 'html',
    html: '<hr><h2 class="subtitle">Section 5. Comments</h2><p><i>This section is optional.</i></p>',
  },

  155: {
    label: 'In what department do you work?',
    type: 'text',
    name: 'department',
    placeholder: 'Accounting',
    validation: {
    },
  },
  156: {
    label: 'How long have you worked at this company?',
    type: 'text',
    name: 'employment-length',
    placeholder: '4 years',
    validation: {
    },
  },
  157: {
    label: 'Which of the following best describes your position?',
    type: 'select',
    name: 'employment-position',
    options: [
      'Team Member',
      'Manager',
      'Senior Manager',
    ],
    validation: {
    },
  },
  158: {
    label: 'Do you work full-time or part-time?',
    type: 'select',
    name: 'employment-time',
    options: [
      'Full-time',
      'Part-time',
    ],
    validation: {
    },
  },
};
